/**
 * Slider Component
 *
 * @file slider.js
 */

// Swiper'ı ve gerekli CSS dosyalarını içe aktar
// import Swiper from 'swiper';
import $ from 'jquery';
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade, Controller, Thumbs, Mousewheel, EffectCards, EffectCoverflow } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';
import 'swiper/css/thumbs';
import 'swiper/css/mousewheel';
import 'swiper/css/effect-cards';
import 'swiper/css/effect-coverflow';

const slider = (() => {
  /**
   * fullSlider
   * Full width slider settings
   */
  const updatePagination = (swiper) => {
    const current = swiper.realIndex + 1;
    const total = swiper.slides.length;
    const progress = ((current - 1) / (total - 1)) * 100;

    const currentElement = swiper.el.querySelector('.home-slide-swiper-pagination .swiper-pagination-current');
    if (currentElement) {
      currentElement.textContent = current;
    }
    const totalElement = swiper.el.querySelector('.home-slide-swiper-pagination .swiper-pagination-total');
    if (totalElement) {
      totalElement.textContent = total;
    }
    const progressElement = swiper.el.querySelector('.home-slide-swiper-pagination .swiper-pagination-progressbar-filled');
    if (progressElement) {
      progressElement.style.width = `${progress}%`;
    }
  };

  const fullSlider = () => {
    const fullSliderC = new Swiper('.home-full-slide-carousel', {
      modules: [Navigation, Pagination, Autoplay, EffectFade],
      loop: false,
      loopAdditionalSlides: 0,
      speed: 3000,
      autoplay: {
        delay: 5000, // 3 saniyede bir otomatik geçiş
        disableOnInteraction: false,
      },
      pagination: false,
      navigation: {
        nextEl: ".home-slide-next",
        prevEl: ".home-slide-prev",
      },
      on: {
        init: function () {
          updatePagination(this);
        },
        slideChange: function () {
          updatePagination(this);
        },
      },
    });
  };

  const whatAboutWonderSliders = () => {
    const whatAboutWonderSlidersC = new Swiper('.what-about-wonder-slide.slide-style-1', {
      modules: [Navigation, Pagination, Autoplay, EffectFade],
      loop: false,
      loopAdditionalSlides: 0,
      pagination: false,
      slidesPerView: 3,
      spaceBetween: 20,
      navigation: {
        nextEl: ".home-what-about-wonder-inner-tab-content-item.style-1 .what-about-wonder-slidde-navigation-next",
        prevEl: ".home-what-about-wonder-inner-tab-content-item.style-1 .what-about-wonder-slidde-navigation-prev",
      },
      breakpoints: {
        992: {
          slidesPerView: 3,
        },
        680: {
          slidesPerView: 2,
        },
        0: {
          slidesPerView: 1,
        },
      },
    });
    const whatAboutWonderSlidersC2 = new Swiper('.what-about-wonder-slide.slide-style-2', {
      modules: [Navigation, Pagination, Autoplay, EffectFade],
      loop: false,
      loopAdditionalSlides: 0,
      pagination: false,
      slidesPerView: 3,
      spaceBetween: 20,
      navigation: {
        nextEl: ".home-what-about-wonder-inner-tab-content-item.style-2 .what-about-wonder-slidde-navigation-next",
        prevEl: ".home-what-about-wonder-inner-tab-content-item.style-2 .what-about-wonder-slidde-navigation-prev",
      },
      breakpoints: {
        992: {
          slidesPerView: 3,
        },
        680: {
          slidesPerView: 2,
        },
        0: {
          slidesPerView: 1,
        },
      },
    });
    const whatAboutWonderSlidersC3 = new Swiper('.what-about-wonder-slide.slide-style-3', {
      modules: [Navigation, Pagination, Autoplay, EffectFade],
      loop: false,
      loopAdditionalSlides: 0,
      pagination: false,
      slidesPerView: 3,
      spaceBetween: 20,
      navigation: {
        nextEl: ".home-what-about-wonder-inner-tab-content-item.style-3 .what-about-wonder-slidde-navigation-next",
        prevEl: ".home-what-about-wonder-inner-tab-content-item.style-3 .what-about-wonder-slidde-navigation-prev",
      },
      breakpoints: {
        992: {
          slidesPerView: 3,
        },
        680: {
          slidesPerView: 2,
        },
        0: {
          slidesPerView: 1,
        },
      },
    });
  };

  const videoGallerySlider = () => {
    const videoGallerySliderC = new Swiper('.video-gallery-slide', {
      modules: [Navigation, Pagination, Autoplay],
      loop: false,
      loopAdditionalSlides: 0,
      pagination: false,
      slidesPerView: 3,
      spaceBetween: 20,
      navigation: {
        nextEl: ".video-gallery-navigation-next",
        prevEl: ".video-gallery-navigation-prev",
      },
      breakpoints: {
        992: {
          slidesPerView: 3,
        },
        680: {
          slidesPerView: 2,
        },
        0: {
          slidesPerView: 1,
        },
      },
    });
  };

  const homeStorySlider = () => {
    const homeStorySliderC = new Swiper('.home-story-slider', {
      modules: [Navigation, Pagination, Autoplay, EffectFade],
      loop: true,
      loopAdditionalSlides: 0,
      effect: 'fade',
      spaceBetween: 0,
      navigation: {
        nextEl: '.home-story-slider-navigation-next',
        prevEl: '.home-story-slider-navigation-prev',
      },
    });
  };

  const init = () => {
    fullSlider();
    whatAboutWonderSliders();
    videoGallerySlider();
    homeStorySlider();
  };

  return {
    init,
  };
})();

export default slider;
